import React,{useState,useEffect,}from 'react'
import { Table,Space,Tag, Radio, Flex, Form,} from 'antd';
import Main from '../../cpn/Main'
import {useGwGoodsListQuery,} from '../../store/ReactWebSiteApi';
import WebGoodsEdit from './WebGoodsEdit';
import WebGoodsDel from './WebGoodsDel';
import WebGoodsAudit from './WebGoodsAudit';
import GetType from '../../gf/web/GetType';
import WebGoodsAdd from './WebGoodsAdd';
import WebGoodsSpecList from '../goodsSpec/WebGoodsSpecList';
import Bnszc from './Bnszc';
function WebGoodsList() {     
    const [query,setQuery] = useState({
        eowg_e_id:localStorage.getItem('e_id'),
        eowg_sub_type_id:'',
        eowg_type_id:'',
        eowg_state:'',
    })
    const {data,isSuccess} = useGwGoodsListQuery(query,{refetchOnMountOrArgChange:1})    
    const [list, setList] = useState();
    useEffect(() => {
        if(isSuccess){            
            if(data.Status==='success'){
                const newArr = data.Result.map(item => {
                    const {eowg_id:key,eowg_name,eowgt_id,eowgts_id,eowg_sub_name,eowg_content,eowg_uname,eowg_ctime,eowg_update_ctime,eowg_update_uname,eowgt_name,eowgts_name,eowg_image_file,eowg_state,eowg_serial_number,guige,eowg_shouming} = item;
                    return item = {key,eowg_name,eowgt_id,eowgts_id,eowg_sub_name,eowg_content,eowg_uname,eowg_ctime,eowg_update_ctime,eowg_update_uname,eowgt_name,eowgts_name,eowg_image_file,eowg_state,eowg_serial_number,guige,eowg_shouming}
                })                           
                const sortArr = newArr.sort((a, b) => {
                    return +a.eowg_serial_number - +b.eowg_serial_number;
                })
                setList(sortArr)
            }else{
                setList('')
            }
            
        }
    }, [data, isSuccess])   
    const columns = [      
        {
            key: 'eowg_name',
            title: '商品名称',
            dataIndex:'eowg_name',   
            render:(text,record) => <h3>{text}</h3>         
        },                           
        {
            key: 'eowg_serial_number',
            title: '序号/编号',
            dataIndex:'eowg_serial_number', 
            sorter: (a, b) => +a.eowg_serial_number - +b.eowg_serial_number,              
            render:(text,record) => <>{text} / {record.key}</>
        },            
        {
            key: 'eowgt_name',
            title: '系统类型',
            dataIndex:'eowgt_name',         
            render:(text,record) => <>{text + '-'+record.eowgt_id} / {record.eowgts_name + '-'+record.eowgts_id}</>
        },                        
               
           
        {
            key: 'num',
            title: '状态',            
            dataIndex: 'eowg_state',
            render:(text) => {
                if(text==='2'){
                    return<Tag color='green'>待上架</Tag>
                }else{
                    return<Tag color='#e20001'>已上架</Tag>
                }
            }
        },       
        {
            key: 'time',
            title: '操作记录',
            render: (_,record) => {
                return <>
                    <div>新建时间：{record.eowg_ctime + record.eowg_uname}</div>
                    <div>修改时间：{record.eowg_update_ctime + record.eowg_update_uname}</div>
                </>
            }
        },
        {
            key: 'action',
            title: '操作',
            render: (_, record) => {
                return <>
                    <Space>
                        <WebGoodsEdit eowg_id={record.key} />
                        <WebGoodsDel  eowg_id={record.key} />
                        <WebGoodsAudit eowg_state={record.eowg_state}  eowg_id={record.key} />
                        <WebGoodsSpecList eowg_id={record.key} eowg_name={record.eowg_name} />
                        <Bnszc 
                             eowg_id={record.key}
                             eowg_name={record.eowg_name}
                             eowgts_name={record.eowgts_name}
                             eowgts_id={record.eowgts_id}
                             eowgt_name={record.eowgt_name}
                             eowgt_id={record.eowgt_id}
                             eowg_content={record.eowg_content}
                             eowg_uname={record.eowg_uname}
                             eowg_ctime={record.eowg_ctime}
                             eowg_update_ctime={record.eowg_update_ctime}
                             eowg_update_uname={record.eowg_update_uname}
                             eowgg_id={record.guige.length>0?record.guige[0].eowgg_id:''}
                             eowgg_name={record.guige.length>0?record.guige[0].eowgg_name:''}    
                             eowg_shouming={record.eowg_shouming}
                                                     
                        />
                        
                    </Space>
                </>
            }
        },
    ]
    
    return (
        <Main selectedKeys={['/WebGoodsList']}  >
            <Flex style={{ marginBottom: 16 }} justify='space-between'>
                <Space>
                    <Form layout='inline'>
                        <GetType
                            label='类型'
                            name='eowg_type_id' 
                            subname='eowg_sub_type_id'
                            getType={(e,f) => {
                                setQuery(prev=>({...prev,eowg_type_id:e,eowg_sub_type_id:f}))
                            }}
                            formStyle={{marginBottom:"0"}}
                        /> 
                    </Form>
                    <Radio.Group>
                        <Radio value='0' onClick={()=>{setQuery(prev=>({...prev,eowg_state:''}))}}>全部</Radio>
                        <Radio value='1' onClick={()=>{setQuery(prev=>({...prev,eowg_state:'1'}))}}>已上架</Radio>
                        <Radio value='2' onClick={()=>{setQuery(prev=>({...prev,eowg_state:'2'}))}}>已下架</Radio>
                    </Radio.Group>               
                </Space> 
                <WebGoodsAdd />
            </Flex>          
            <Table 
                columns={columns} 
                style={{marginTop:'20px'}} 
                dataSource={list}
                rowKey="key"
                pagination={{
                    showSizeChanger:true,
                    defaultPageSize:50,
                    showTotal:(total) => `共${total}条`,
                    onChange:(e,f) => {
                        localStorage.setItem('ebn_query_page',e);
                        localStorage.setItem('ebn_query_page_size',f);
                    },
                }}
            />            
        </Main>
    )
}

export default WebGoodsList